import React, { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import { AGENT_CATEGORIES } from "@lib/agentConsole";
import type { I18nT } from "@lib/dashboardI18n";

const DataAgentsForNRO = lazy(() =>
  import("@scenes/AgentsList").then((module) => ({
    default: () => React.createElement(module.AgentConsoleForNro, { category: AGENT_CATEGORIES.DATA }),
  }))
);

export const dataAgentsNRO: NavigationRoutingObject = {
  Component: DataAgentsForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  icon: "new-nav-system-agent-management",
  heading: (t: I18nT<"dashboard-navigation">) => t("data-agents-nro-heading", "Data Agents"),
  pageNameForTracking: () => "Data Agents",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("data-agents-nro-description", "Enrich and transform data across your catalogs and user profiles"),
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
